<ng-container [formGroup]="group">
  <div [formArrayName]="model.id" [id]="id" [ngClass]="getClass('element', 'control')">
    @for (groupModel of model.groups; track groupModel; let idx = $index) {
    <div role="group" [formGroupName]="idx" [ngClass]="[getClass('element', 'group'), getClass('grid', 'group')]">
      <ng-container *ngTemplateOutlet="startTemplate?.templateRef; context: groupModel"></ng-container>
      @for (_model of groupModel.group; track _model) {
      <dynamic-material-form-control
        [context]="groupModel"
        [group]="array.at(idx)"
        [hidden]="_model.hidden"
        [layout]="formLayout"
        [model]="_model"
        [templates]="templates"
        [hostClass]="[getClass('element', 'children'), getClass('grid', 'children')]"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
        (matEvent)="onCustomEvent($event, null, true)"
      ></dynamic-material-form-control>
      }
      <ng-container *ngTemplateOutlet="endTemplate?.templateRef; context: groupModel"></ng-container>
    </div>
    }
  </div>
</ng-container>
